<template>
<div>
	<standard v-if="event.template == 'Preview 1'" :event="event" :imageBucket="imageBucket" :imageFileURL="imageFileURL" :logoFileURL="logoFileURL"></standard>
	<enhanced v-if="event.template != 'Preview 1'" :event="event" :imageBucket="imageBucket" :imageFileURL="imageFileURL" :logoFileURL="logoFileURL"></enhanced>
</div>
</template>

<script>
import standardTemplate from "./standardTemplate.vue";
import enhancedTemplate from "./enhancedTemplate.vue";

export default {
  props: ["event"],

  created() {
    this.imageBucket = window.imageBucket;
  },

  data: function() {
    return {
      imageBucket: "",
      internationalEvent: false
    };
  },

  computed: {
    logoFileURL: function() {
      if (this.event.image1) {
        return (
          "https://s3-eu-west-1.amazonaws.com/" +
          this.imageBucket +
          "/" +
          this.event.id +
          "/" +
          this.event.image1 +
          "?" +
          Math.random()
        );
      } else {
        return "";
      }
    },

    imageFileURL: function() {
      if (this.event.image2) {
        return (
          "https://s3-eu-west-1.amazonaws.com/" +
          this.imageBucket +
          "/" +
          this.event.id +
          "/" +
          this.event.image2 +
          "?" +
          Math.random()
        );
      } else {
        return "";
      }
    }
  },

  methods: {},

  components: {
    standard: standardTemplate,
    enhanced: enhancedTemplate
  }
};
</script>
